window.Auth = {
	hideMsg: function ($form) {
		$form.find('.msg').hide();
	},
	showError: function ($form, msg) {
		$form.find('.msg.error').html(msg).show();
	},
	showSuccess: function ($form, msg) {
		$form.find('.msg.success').html(msg).show();
	},

	hideModalAuth: function () {
		$modal = $("#modal-auth-user");
		$modal.modal('hide');
	},
	showModalEmail: function () {
		$modal = $("#modal-submit-email");
		$modal.modal('show');
		Auth.hideMsg($modal.find('form'));
	},

	post: function ($form, callback) {
		var route = $form.attr('action');

		$.ajax({
			url: route,
			type: "POST",
			data: $form.serialize(),
			success: function (data) {
				callback(data);
			},
			error: function (xhr) {
				callback(JSON.parse(xhr.responseText));
			},
		});
	},

	showAuthModal: function (text) {
		setTimeout(function () {
			let $modal = $("#modal-auth-success");
			$modal.find('h4').html(text);
			$modal.modal('show');
			setTimeout(function () { $modal.modal('hide'); }, 1000);
		}, 500);
	},
};

$(document).ready(function () {
	$("#form-reg").submit(function () {
		var $form = $(this);

		Auth.hideMsg($form);
		$form.find('[type=submit]').attr('disabled', 'disabled');

		Auth.post($form, function (data) {
			$form.find('[type=submit]').removeAttr('disabled');

			if (data.errors) {
				var msg = data.errors[Object.keys(data.errors)[0]];
				Auth.showError($form, msg);
			} else if (data.error) {
				Auth.showError($form, data.msg);
			} else if (data.redirect_to) {
				location.href = data.redirect_to;
			}
		});

		return false;
	});

	$("#form-login").submit(function () {
		var $form = $(this);

		Auth.hideMsg($form);
		$form.find('[type=submit]').attr('disabled', 'disabled');

		Auth.post($form, function (data) {
			$form.find('[type=submit]').removeAttr('disabled');

			if (data.errors) {
				var msg = data.errors[Object.keys(data.errors)[0]];
				Auth.showError($form, msg);
			} else if (data.error) {
				Auth.showError($form, data.msg);
			} else if (data.redirect_to) {
				location.href = data.redirect_to;
			}
		});

		return false;
	});

	$("#form-forgot").submit(function () {
		var route = $(this).attr('action');
		var params = $(this).serializeArray();
		var $form = $(this);

		Auth.hideMsg($form);
		$form.find('[type=submit]').attr('disabled', 'disabled');

		$.post(route, params, function (data) {
			if (data.error) {
				Auth.showError($form, data.msg);
				$form.find('[type=submit]').removeAttr('disabled');
			} else {
				Auth.showSuccess($form, data.msg);
			}
		});

		return false;
	});

	$("#form-email").submit(function () {
		var route = $(this).attr('action');
		var params = $(this).serializeArray();
		var $form = $(this);

		Auth.hideMsg($form);
		$form.find('[type=submit]').attr('disabled', 'disabled');

		$.post(route, params, function (data) {
			if (data.error) {
				Auth.showError($form, data.msg);
				$form.find('[type=submit]').removeAttr('disabled');
			} else {
				location.href = data.redirect_to;
			}
		});

		return false;
	});

	$('[data-toggle=forgot-tab]').click(function () {
		let $forgot = $('.forgot-tab'),
			$auth = $('.auth-tabs');

		$forgot.slideDown('slow');
		$auth.slideUp('slow');

		return false;
	});

	$('[data-toggle=auth-tabs]').click(function () {
		let $forgot = $('.forgot-tab'),
			$auth = $('.auth-tabs');

		$auth.slideDown('slow');
		$forgot.slideUp('slow');

		return false;
	});
});
